module.exports = __webpack_public_path__ + "img/midi.51be2ef2.png";